import { TreeNode } from "react-dropdown-tree-select";
import { DishForTree } from "../../../../../interfaces/meMenuInterfaces/interfaces";
import { cloneNameToDisplay } from "../../../utils/cloneNameUtils";
import { TFunction } from "i18next";

export const prepareTreeData = (dishes: DishForTree[], selectedIds: number[] = [], t: TFunction): TreeNode[] => {
    const categoryMap = new Map<number, TreeNode>();

    dishes.forEach((dish) => {
        const { id, name, categoryId, categoryName, subcategoryId, subcategoryName } = dish;

        if (!categoryMap.has(categoryId)) {
            categoryMap.set(categoryId, {
                label: categoryName,
                value: `cat_${categoryId}`,
                children: [],
                expanded: true,
            });
        }

        const categoryNode = categoryMap.get(categoryId)!;

        const leaf: TreeNode = {
            label: cloneNameToDisplay(name, t),
            value: String(id),
            checked: selectedIds.includes(id),
        };

        if (subcategoryId && subcategoryName) {
            let subNode = categoryNode.children!.find(
                (child: any) => child.isSubcategory === true && child.subcategoryId === subcategoryId
            ) as TreeNode | undefined;

            if (!subNode) {
                subNode = {
                    isSubcategory: true as any,
                    subcategoryId: subcategoryId as any,
                    label: subcategoryName,
                    value: `sub_${subcategoryId}`,
                    children: [],
                    expanded: true,
                } as any;

                categoryNode.children!.push(subNode);
            }

            subNode.children!.push(leaf);
        } else {
            categoryNode.children!.push(leaf);
        }
    });

    const computeState = (node: TreeNode): { total: number; selected: number } => {
        if (!node.children || node.children.length === 0) {
            const isChecked = !!node.checked;
            return { total: 1, selected: isChecked ? 1 : 0 };
        }

        let total = 0;
        let selected = 0;

        node.children.forEach((child: TreeNode) => {
            const res = computeState(child);
            total += res.total;
            selected += res.selected;
        });

        node.checked = selected > 0 && selected === total;
        return { total, selected };
    };

    const roots = Array.from(categoryMap.values());
    roots.forEach((root) => computeState(root));

    return roots;
};
